<template>
    <div>
        <TitleBar>
          <template v-slot:title><translate>Trips</translate></template>
          <template v-slot:buttons>
            <!-- <OnboardingIntroLink :onboarding-intro="'onboarding_web_trips'" /> -->
            
            <GekkoButton @click="addTrip" :text="$gettext('New')" icon="fa-solid fa-plus" class="mr-2" />

            <b-dropdown class="icon-toggle ui-dashboard-menu-dropdown" variant="outline-primary" right no-caret>
              <template #button-content>
                <font-awesome-icon icon="fa-solid fa-ellipsis-vertical" />
              </template>
              <b-dropdown-item @click="download">
                <font-awesome-icon icon="fa-solid fa-download" />
                <span v-translate>Download</span>
              </b-dropdown-item>

              <b-dropdown-item
                :to="{ name: 'TripsReport' }"
                class="premium-badge--inline"
              >
                <font-awesome-icon icon="fa-solid fa-chart-column" />
                <span v-translate>Trips report</span>
                <GkBadge icon="fa-solid fa-crown" icon-only type="premium" />
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </TitleBar>
        <div class="content">
            <TripTable />
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import TripTable from "@/components/trips/TripTable"
import GekkoButton from "@/components/GekkoButton";
import TripService from "@/store/services/trip.service";
import { mapGetters } from "vuex"
// import OnboardingIntroLink from "@/components/ui/OnboardingIntroLink"

export default {
    name: 'Trips',
    components: { 
        TitleBar, 
        TripTable, 
        GekkoButton,
        // OnboardingIntroLink
    },
    data() {
        return {
            
        }
    },
    computed: {
        ...mapGetters({
            getCompanyId: 'main/getCompanyId'
        })
    },
    methods: {
        addTrip() {
            this.$router.push({name: 'AddTrip'});
        },
        download() {
            let filters = this.$store.getters['filterStore/getFilter'];
            filters['company_profile'] = this.getCompanyId;
            TripService.exportTrips(filters)
              .then(() => {
                 this.$store.commit('setAlert', {
                  title: this.$gettext('Trips Download'),
                  text: this.$gettext('Your download is being prepared, check your downloads page to download the file.'),
                  variant: 'info',
                  duration: 4
                })
                this.$router.push({ name: 'Files' })
              })
              .catch(error => {
                if (error.status === 429) {
                  const alert_text = this.$gettext('You\'ve reached your download limit for today.')
                  this.$store.commit('setAlert', {title: this.$gettext('Trips Download'), text:alert_text, variant:'danger',duration:4});
                  this.$store.commit('togglePremiumModal', 'web_files_download_limit')
                } else {
                  this.$store.commit('setAlert', {
                    title: this.$gettext('Trips Download Error'),
                    text: this.$gettext('An error occurred while attempting to download your trips.'),
                    variant: 'danger',
                    duration: 4
                  })
                }
            });
        }
    }
}
</script>

<style scoped>

</style>